// This is missing from the service schema for some reason.
export enum FirstWeekOfYear {
    FirstDay = 0,
    FirstFourDayWeek = 1,
    FirstFullWeek = 2
}
